import { SuperAgentLevelViewContainer } from '../SuperAgentLevelViewContainer';

export const getSuperAgentBadge = (userTrustLevelNumber?: number, userTrustLevelName?: string) => {
  if (!userTrustLevelNumber || !userTrustLevelName) {
    return null;
  }

  return <SuperAgentLevelViewContainer levelNumber={userTrustLevelNumber} levelName={userTrustLevelName} />;
};
